export default __webpack_public_path__ + "static/media/sticker-b.6c070b75.png";